import { render, staticRenderFns } from "./TechnicalAnalysis.vue?vue&type=template&id=fbe75a8a&scoped=true&"
import script from "./TechnicalAnalysis.vue?vue&type=script&lang=js&"
export * from "./TechnicalAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalAnalysis.vue?vue&type=style&index=0&id=fbe75a8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe75a8a",
  null
  
)

export default component.exports